/* BannerAppendage.js */

"use strict";
const _ = require("lodash");
const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19";

class BannerCheckAppendage {
    constructor(router, userSession, SystemConfig) {
        this._router = router;
        this._userSession = userSession;
        this._SystemConfig = SystemConfig;
        this._sessionStorage = window.sessionStorage;
    }
    startUp(fullRouteInfo) {
        let routeDestSection = _.get(fullRouteInfo, "newRouteDetails.s", false);
        // Case 25733
        if (!routeDestSection) {
            return true;
        }
        const routeSR = _.get(fullRouteInfo, "newRouteDetails.sr", false);
        const redirect = _.get(
            fullRouteInfo,
            "newRouteDetails.rd.redirect",
            _.get(fullRouteInfo, "newRouteDetails", false)
        );
        const routeRd = Object.assign({}, {triggeredBy: "Banner", redirect});
        if (
            routeDestSection === "LoginCenter" ||
            routeDestSection === "LogoutCenter" ||
            routeDestSection === "Eula" ||
            routeDestSection === "PasswordReset" ||
            routeDestSection.toLowerCase().search("fail") >= 0
        ) {
            return true;
        }
        if (routeSR && routeSR === "Organization/Licensing") {
            return true;
        }
        let userInfo = this._userSession.getUser();
        let userAuthenticated = this._userSession.isConnectedAndAuthenticated();
        if (!userInfo || !userAuthenticated) {
            const token = this._userSession.token || this._localStorage.getToken();
            localStorage.clear();
            location.href = `${window.origin}/session/logout/${token}`;
            return false;
        } else {
            if (!userInfo.eulaAcceptTime) {
                return true;
            }
            const bannerAccepted = this._sessionStorage.getItem(
                this._userSession.token + "isBannerAccepted"
            );

            return this._SystemConfig
                .loadSystemConfig(GSO_ID)
                .then((systemConfig) => {
                    const bannerData = systemConfig.banner;
                    // check for accept time first, if it is not present go to banner
                    if (
                        bannerData &&
                        ((bannerData.enable && !userInfo.bannerAcceptTime) ||
                            (bannerData.enable &&
                                bannerData.updatedOn &&
                                new Date(bannerData.updatedOn).getTime() >
                                    new Date(userInfo.bannerAcceptTime).getTime()))
                    ) {
                        this._router.goTo({
                            app: "GameConsole",
                            s: "Banner",
                            rd: routeRd,
                            sln: null,
                        });
                        return false;
                    }
                    // if we reach here it means bannerAcceptTime is available
                    // check if displayMode is "ALWAYS"
                    if (bannerData && bannerData.enable && bannerData.displayMode === "ALWAYS") {
                        // check if banner accepted from session
                        if (bannerAccepted) {
                            return true;
                        }
                        // if above condtion fails redirect to banner
                        this._router.goTo({
                            app: "GameConsole",
                            s: "Banner",
                            rd: routeRd,
                            sln: null,
                        });
                        return false;
                    }
                    // if displayMode is not 'ALWAYS' return true as bannerAcceptTime is available
                    return true;
                })
                .catch((err) => {
                    console.log("Unable to get banner details", err);
                    return false;
                });
        }
    }
}
module.exports = BannerCheckAppendage;
module.exports.$inject = ["$teve.router", "$teve.userSession", "$teve.entities.SystemConfig"];
